<template>
  <div>
    <navbar />
    <main>
      <div
        class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75"
      >
        <div
          class="absolute top-0 w-full h-full bg-center bg-cover"
          style="
            background-image: url('https://5tukodaujyktpifher2u3xdsjrl3c5kbd4aptq6kslcutmbc.arweave.net/7OinDBROFTegpyR1Tdx_yTFexdUEfAPnDypL_FSbAiU');
          "
        >
          <span
            id="blackOverlay"
            class="w-full h-full absolute opacity-75 bg-black"
          ></span>
        </div>
        <div class="container relative mx-auto">
          <div class="items-center flex flex-wrap">
            <div class="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
              <div class="pr-12">
                <h1 class="text-white font-semibold text-5xl">
                  Ready for NFTs in space?
                </h1>
                <p class="mt-4 text-lg text-blueGray-200">
                  The 1st Profit Sharing Community in the metaverse <br/>
                  showcasing and selling NFTs in virtual reality.
                </p>
              </div>
              <div class="mt-12">
                <a
                  href="https://diamondapp.com/u/artstation"
                  target="_blank"
                  class="get-started text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-emerald-600 active:bg-emerald-500 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
                >
                  ArtStation Feed
                </a>
                <a
                  href="https://community.xyz/#gkYwvqQPFdQVvWwkZbhhaGBG9AYcnc1DOHQwngsV_MA"
                  class="github-star ml-1 text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-blueGray-700 active:bg-blueGray-600 uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
                  target="_blank"
                >
                  Token activity
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
          style="transform: translateZ(0);"
        >
          <svg
            class="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              class="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
      </div>

      <section class="pb-20 bg-blueGray-200 -mt-24">
        <div class="container mx-auto px-4">
          <div class="flex flex-wrap">
            <div class="lg:pt-12 w-full md:w-4/12 px-4 text-center">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
              >
                <div class="px-4 py-5 flex-auto">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-600"
                  >
                    <i class="far fa-eye"></i>
                  </div>
                  <h6 class="text-xl font-semibold">Community curated</h6>
                  <p class="mt-2 mb-4 text-blueGray-500">
                    Holders of the [ART] token can use it to vote on accepting the NFT art for display and define the schedule of showcases.
                  </p>
                </div>
              </div>
            </div>

            <div class="pt-4 w-full md:w-4/12 px-4 text-center">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
              >
                <div class="px-4 py-5 flex-auto">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-600"
                  >

                    <i class="fas fa-bullhorn"></i>
                  </div>
                  <h6 class="text-xl font-semibold">Open collaboration</h6>
                  <p class="mt-2 mb-4 text-blueGray-500">
                    The station is displaying and selling NFTs stored on Arweave and is using DeSo for social graph data about the NFTs history.
                  </p>
                </div>
              </div>
            </div>

            <div class="lg:pt-12 w-full md:w-4/12 px-4 text-center">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg"
              >
                <div class="px-4 py-5 flex-auto">
                  <div
                    class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-purple-500"
                  >
                    <i class="fas fa-retweet"></i>
                  </div>
                  <h6 class="text-xl font-semibold">User-owned automation</h6>
                  <p class="mt-2 mb-4 text-blueGray-500">
                    Artstation is sharing its blueprints to other communities that want to own, manage and profit from virtual assets in the metaverse.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-wrap items-center mt-12">
            <div class="w-full md:w-5/12 px-4 mr-auto ml-auto">
              <div
                class="text-emerald-600 p-1 text-center inline-flex items-center justify-center w-16 h-16 mb-8"
              >
                <i class="fas fa-user-friends text-4xl"></i>
              </div>
              <h3 class="text-3xl mb-2 font-semibold leading-normal">
                Profit Sharing Communities
              </h3>
              <p
                class="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600"
              >
                Work on what you care about and accumulate revenue generating tokens by participating in the emerging, blockchain enabled economy.
              </p>
              <p
                class="text-lg font-light leading-relaxed mt-0 mb-4 text-blueGray-600"
              >
                Profit sharing communities facilitate collaboration between artists, builders and influencers, providing a decentralized model of generating value in the metaverse.
              </p>
              <a 
                href="https://coinmarketcap.com/alexandria/article/profit-sharing-communities-a-deep-dive-by-arweave" 
                class="font-bold text-blueGray-700 mt-8"
                target="_blank"
                title="Article on Coinmartketcap about profit sharing communities from India Raybould (Arweave)" 
              >
                Read more about PSCs ...
              </a>
            </div>

            <div class="w-full md:w-4/12 px-4 mr-auto ml-auto">
              <div
                class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg bg-blueGray-800"
              >
                <img
                  alt="Welcome to ArtStation"
                  src="https://rcvp3xou4myzl4cpcvoz6z3ooetmlpmwbxclfu5aiuaicnb2km.arweave.net/iKr93dTjMZXwTxVdn2ducSbFvZY-NxLLToEUAgTQ6Uw"
                  class="w-full align-middle rounded-t-lg"
                />
                <blockquote class="relative p-8 mb-4">
                  <svg
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 583 95"
                    class="absolute left-0 w-full block h-95-px -top-94-px"
                  >
                    <polygon
                      points="-30,95 583,95 583,65"
                      class="text-blueGray-800 fill-current"
                    ></polygon>
                  </svg>
                  <h4 class="text-xl font-bold text-white">
                    Showcasing art on moon's orbit
                  </h4>
                  <p class="text-md font-light mt-2 text-white">
                    Space is one of the most inspiring places in the universe, a canvas taking many shapes, able to be adapted to the needs of showcased art.
                  </p>
                  <p class="mt-4">
                    <a 
                      href="https://astronation.world/?ref=artstation" 
                      class="font-bold text-white mt-8"
                      target="_blank"
                      title="Homepage of Astronation - the virtual world of ArtStation" 
                    >
                      Read more about Astronation ...
                    </a>
                  </p>
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="relative py-20">
        <div
          class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style="transform: translateZ(0);"
        >
          <svg
            class="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              class="text-white fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>

        <div class="container mx-auto px-4">
          <div class="items-center flex flex-wrap">
            <div class="w-full md:w-4/12 ml-auto mr-auto px-4">
              <img
                alt="..."
                class="max-w-full rounded-lg shadow-lg"
                src="https://do3xrgwkawl455j7cjm4ijcwujhcnpunktzcl5synnwumogk3a.arweave.net/G7d4msoFl-871PxJZxCRWok4mvo1U8iX2WGttRjjK2M"
              />
            </div>
            <div class="w-full md:w-5/12 ml-auto mr-auto px-4">
              <div class="md:pr-12">
                <div
                  class="text-lightBlue-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6"
                >
                  <i class="fas fa-rocket text-4xl"></i>
                </div>
                <h3 class="text-3xl font-semibold">Web3 enabled VR station</h3>
                <p class="mt-4 text-lg leading-relaxed text-blueGray-500">
                  The station that started from a simple idea, is already orbiting the moon Eir in the virtual world of Astronation... but the construction is still ongoing. Currently, we're automating its governance processes on top of the Arweave blockchain.
                </p>
                <p class="mt-4">
                  <a 
                      href="https://discord.gg/NJQeACHgjY" 
                      class="font-bold mt-8"
                      target="_blank"
                      title="Invitation to join the ArtStation's channel on Astronation's Discord server" 
                    >
                      Join the builders on Discord ...
                    </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr/>
      <section class="pt-20 pb-48">
        <div class="container mx-auto px-4">
          <div class="flex flex-wrap justify-center text-center mb-24">
            <div class="w-full lg:w-8/12 px-4">
              <h2 class="text-4xl font-semibold">Meet the founding crew!</h2>
              <p class="text-lg leading-relaxed m-4 text-blueGray-500">
                Recruited among the visionaries that arrived on the Deso social blockchain,
                so early, that they had to wait for NFTs to launch before creating the first, founding collection for ArtStation!
              </p>
            </div>
          </div>
          <div class="flex flex-wrap">
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLfo5DCFGgHTrEkgvPKmgEC3koPS3h8hojsGh4od5BcFuBgQmPyT?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="Digitalize"
              role="Founding Artist"
              link="https://realdigitalize.com/"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLg2KY9qZ44GFxcMj7QKdSfgcZeEQNYtDt7gHNw5NqRV1YsZ215A?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="RDGroupRome"
              role="Founding Artist"
              link="https://rdgrouphoustonoffice.threadless.com/"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLi56ZRdvCAkfh5GJN9dBgUzviFt96nQmdi25fK6cFzFYyRaP493?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="Xandertoshi"
              role="Founding Artist"
              link="https://diamondapp.com/u/Xandertoshi"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLfuFvmoDWNyEV1y1ZHMqLqj77wfa2c5Wb1MpfjfYFavmuyKQGCz?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="fizzler"
              role="Founding Artist"
              link="https://diamondapp.com/u/fizzler"
            ></founding-crew-box>
          </div>
          <div class="flex flex-wrap mt-12">
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLi2y6Y84yVrP8E59B5daneyLSt9sNbkdgx485zswkt1BF43yxok?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="TheTokenized"
              role="Founding Artist"
              link="https://diamondapp.com/u/thetokenized"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLgiiAzrUppCAKDtrm7sMP2vjAguo4VBEpcTN2JPx1hXBY94SKQk?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="falafeldude"
              role="Falafel delivery"
              link="https://diamondapp.com/u/falafeldude"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLfjp1xGV7SZVEWW5YVSGYh5w6KWjY28woi8hcNh1BjJx5nxkPxt?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="Bringemvaught"
              role="Rocket fuel & support"
              link="https://diamondapp.com/u/Bringemvaught"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLhUqqqDiKw9zvfzShyKQbqETxTFdvVM8vzrjwSRw42V2M8XLx7G?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="Aikon"
              role="Rocket fuel & support"
              link="https://diamondapp.com/u/Aikon"
            ></founding-crew-box>
          </div>
          <div class="flex flex-wrap mt-12">
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLhewEKBC33ckoZftky42SWBSpdW9NWDCyAmLyoMs2jCr6VN1aPL?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="JamesHarbal"
              role="Rocket fuel & support"
              link="https://diamondapp.com/u/JamesHarbal"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLg1xTdgWFS1Lw1EqYhLhmqSj3WV5eKRJWE1TgCghR25d9usgt5u?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="InURfeelz2"
              role="Rocket fuel & support"
              link="https://diamondapp.com/u/InURfeelz2"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLgU67opDhT9bTPsqvue9QmyJLDHRZrSj77cF3P4yYDndmad9Wmx?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="diamondhands"
              role="Adding NFTs to Deso"
              link="https://diamondapp.com/u/diamondhands"
            ></founding-crew-box>
            <founding-crew-box
              profile-pic="https://love4src.com/api/v0/get-single-profile-picture/BC1YLhwpmWkgk2iM9yTSxzgUVhYjgessSPTiVHkkK9pMrhweqJnWrvK?fallback=https://love4src.com/assets/img/default_profile_pic.png"
              nickname="kanshi"
              role="Flight captain"
              link="https://diamondapp.com/u/kanshi"
            ></founding-crew-box>
          </div>
        </div>
      </section>

      <section class="pb-20 relative block bg-blueGray-800">
        <div
          class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
          style="transform: translateZ(0);"
        >
          <svg
            class="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              class="text-blueGray-800 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>

        <div class="container mx-auto px-4 lg:pt-24 lg:pb-64">
          <div class="flex flex-wrap text-center justify-center">
            <div class="w-full lg:w-6/12 px-4">
              <h2 class="text-4xl font-semibold text-white">
                Start showcasing NFTs in space!
              </h2>
              <p class="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400">
                Join the largest NFT exhibition, featuring 100 meter wide billboards, trade stations,
                and free parking for your spaceship!
              </p>
            </div>
          </div>
          <div class="flex flex-wrap mt-12 justify-center">
            <div class="w-full lg:w-3/12 px-4 text-center">
              <div
                class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
              >
                <i class="fas fa-medal text-xl"></i>
              </div>
              <h6 class="text-xl mt-5 font-semibold text-white">
                Best Web3 artists
              </h6>
              <p class="mt-2 mb-4 text-blueGray-400">
                The social graph data and artist onboarding processes are facilitated by the 
                <a href="https://deso.org/"
                  class="font-bold mt-8"
                  target="_blank"
                  title="Arweave homepage" 
                >
                  Deso blockchain.
                </a>
              </p>
            </div>
            <div class="w-full lg:w-3/12 px-4 text-center">
              <div
                class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
              >
                <i class="fas fa-poll text-xl"></i>
              </div>
              <h5 class="text-xl mt-5 font-semibold text-white">
                Open & decentralized data
              </h5>
              <p class="mt-2 mb-4 text-blueGray-400">
                NFTs showcased on the station, are stored on decentralized, blockchain based storage of 
                <a href="https://www.arweave.org/"
                  class="font-bold mt-8"
                  target="_blank"
                  title="Arweave homepage" 
                >
                    Arweave.
                </a>
              </p>
            </div>
            <div class="w-full lg:w-3/12 px-4 text-center">
              <div
                class="text-blueGray-800 p-3 w-12 h-12 shadow-lg rounded-full bg-white inline-flex items-center justify-center"
              >
                <i class="fas fa-lightbulb text-xl"></i>
              </div>
              <h5 class="text-xl mt-5 font-semibold text-white">
                  Open software innovation
              </h5>
              <p class="mt-2 mb-4 text-blueGray-400">
                This model can be replicated since ArtStation is a FOSS dApp deployed on the 
                <a href="https://www.arweave.org/"
                  class="font-bold mt-8"
                  target="_blank"
                  title="Arweave homepage" 
                >
                    Arweave blockchain.
                </a>
              </p>
            </div>
          </div>
        </div>
        <footer-component />
      </section>
    </main>
  </div>
</template>
<script>
import Navbar from "@/components/Navbars/IndexNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";
import FoundingCrewBox from "@/components/Team/DefaultBox.vue";


export default {
  components: {
    Navbar,
    FooterComponent,
    FoundingCrewBox
  },
};
</script>
